const ACTION_PREFIX = `@komigen/mobile-frontend/all-games`;
export const FETCH_CASINO_ALL_GAMES_START = `${ACTION_PREFIX}/FETCH_CASINO_ALL_GAMES_START`;

export const FETCH_CASINO_ALL_GAMES_FINISH = `${ACTION_PREFIX}/FETCH_CASINO_ALL_GAMES_FINISH`;

export const ADD_GAME = `${ACTION_PREFIX}/ADD_GAME`;
